/* eslint-disable */
// @ts-nocheck
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { filter, map, some } from 'lodash';




// Uses window.tsapp
var ctl = tsapp.ctl;

var getMomentTZDateTime = require('ts-util').getMomentTZDateTime;


export class PackageSelectedDatesList extends Component {
    constructor(props) {
        super(props);
    }

    isItemSelected(itemID) {
        return some(this.props.selectedItemIDs, (id) => id == itemID )
    }

    render() {
        // Sort by date?

        var itemsToShow = this.props.items;

        // If in overview mode, we only show stuff that is selected
        if(this.props.overview)
            itemsToShow = filter(itemsToShow, (i) => this.isItemSelected(i.EventDateID));

        var items = map(itemsToShow, function(item) {
            return (
                <li key={item.EventDateID}>
                    <span>{item.Description} - {getMomentTZDateTime(item.Date, item.TimeZone.TZDatabaseID).format(tsapp.tr("program.format.moment.datetime"))}</span>
                </li>
            );
        }.bind(this));

        return (
            <ul>
                {items}
            </ul>
        );
    }
};

PackageSelectedDatesList.propTypes = {
    selectedItems: PropTypes.array,
}
